/**
 * SYSTEM_DESIGN.md §6.5 — Estado vacío.
 *
 * Plantilla única: "No hay [entidad] todavía". El componente la construye, así
 * que no se puede escribir una variante nueva sin salirse del componente.
 *
 * Cuando hay filtros aplicados el mensaje cambia, porque "no hay X todavía" es
 * engañoso si en realidad sí hay datos pero el filtro los excluye.
 */
interface EmptyStateProps {
  /** Entidad en plural y minúscula: "beneficios", "eventos", "talleres". */
  entity: string;
  /** True cuando hay filtros activos: el vacío es del filtro, no de los datos. */
  filtered?: boolean;
  icon?: string;
}

export const emptyMessage = (entity: string, filtered = false) =>
  filtered
    ? `No hay ${entity} que coincidan con los filtros`
    : `No hay ${entity} todavía`;

export const EmptyState = ({ entity, filtered = false, icon }: EmptyStateProps) => (
  <div className="flex flex-column align-items-center justify-content-center gap-3 py-5 text-600">
    {icon && <i className={`${icon} text-4xl`} style={{ color: "var(--info-default)" }} />}
    <span>{emptyMessage(entity, filtered)}</span>
  </div>
);
